import { getTodaysTopHitsId, ValidTerritoryCode } from "@libs/utils";

export const getPlaylistSubtitle = (
  userName: string | undefined,
  countryCode: ValidTerritoryCode,
  playlistUserName?: string,
  id?: string,
): string => {
  if (id?.startsWith("liked_") || playlistUserName === userName) {
    return "by You";
  }
  if (id === "discover_daily" || id === getTodaysTopHitsId(countryCode)) {
    return "by Lissen";
  }
  return `Curator • ${playlistUserName || "Unknown"}`;
};
